import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

export var BrandLink = /*#__PURE__*/_styled("span", true ? {
  target: "ed41syo0"
} : {
  target: "ed41syo0",
  label: "BrandLink"
})(true ? {
  name: "vetbs0",
  styles: "display:grid"
} : {
  name: "vetbs0",
  styles: "display:grid",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi93b3JrZGlyL2xpYnMvdGVtcGxhdGVzL0Zvb3Rlci9Gb290ZXIudmlld3MudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVvQyIsImZpbGUiOiIvd29ya2Rpci9saWJzL3RlbXBsYXRlcy9Gb290ZXIvRm9vdGVyLnZpZXdzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJ1xuXG5leHBvcnQgY29uc3QgQnJhbmRMaW5rID0gc3R5bGVkLnNwYW5gXG4gIGRpc3BsYXk6IGdyaWQ7XG5gXG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});